import React from "react";
import { Box, Rating, Typography } from "@mui/material";

const PlaygroundRating = ({ rating, userRatingsTotal, sx }) => {
  if (typeof rating !== "number") return null;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5, ...sx }}>
      <Rating value={rating} precision={0.1} size="small" readOnly />
      <Typography variant="body2" color="text.secondary">
        {rating.toFixed(1)}
        {userRatingsTotal ? ` (${userRatingsTotal})` : ""}
      </Typography>
    </Box>
  );
};

export default PlaygroundRating;
